/** Pointer event handler factories for long-press detection. */
import { useLongPressDownUpHandlers } from '@/features/tasks/hooks/ui/use-interaction-long-press-down-up';
import { useLongPressMoveCancelHandlers } from '@/features/tasks/hooks/ui/use-interaction-long-press-move';

export function useLongPressPointerHandlers({
  onLongPress,
  onClick,
  ms,
  moveThreshold,
  timerRef,
  startPointRef,
  isLongPressTriggeredRef,
  isMovementExceededRef,
}) {
  const downUp = useLongPressDownUpHandlers({
    onLongPress,
    onClick,
    ms,
    timerRef,
    startPointRef,
    isLongPressTriggeredRef,
    isMovementExceededRef,
  });
  const moveCancel = useLongPressMoveCancelHandlers({
    moveThreshold,
    timerRef,
    startPointRef,
    isMovementExceededRef,
  });

  return { ...downUp, ...moveCancel };
}
